type BackNavigatorProps = {
  left?: React.ReactNode;
  title?: string;
  right?: React.ReactNode;
};
const BackNavigator = ({ title, left, right }: BackNavigatorProps) => {
  return (
    // 1.3.1 Info and Relationships — A: the <nav> landmark needs a name to be
    // distinguishable when a page has more than one navigation region.
    <nav
      aria-label={title ? `${title} header` : "Page header"}
      className="absolute top-0 flex w-full flex-row items-center justify-between overflow-hidden border-b border-gray-300 bg-white px-4 py-3 shadow-sm"
    >
      <div className="flex items-center">{left}</div>

      {/*
        1.3.1 Info and Relationships — A / 2.4.6 Headings and Labels — AA. This was a
        <Label> — a <label> element with no associated control — so every page using
        BackNavigator had no heading at all and screen reader users had nothing to navigate
        to. It is the page title, so it is an h1. The classes reproduce labelVariants plus
        the previously-passed ones, so it renders identically.
      */}
      <h1 className="overflow-hidden text-ellipsis text-center text-sm font-medium leading-none">
        {title}
      </h1>

      <div className="flex items-center">{right}</div>
    </nav>
  );
};

export default BackNavigator;
